import type { ScalarDiffFieldOut } from '@/api/generated/schemas';

/**
 * Whether an import will write this diff row. A locked row is never
 * written — the backend refuses it even with the manual override — and a
 * manually edited row is written only when the operator opts in.
 */
export const willImportApply = (
  field: Pick<ScalarDiffFieldOut, 'manually_edited' | 'import_locked'>,
  overrideManual: boolean
): boolean =>
  !field.import_locked && (overrideManual || !field.manually_edited);

/**
 * Whether the "also overwrite manually edited values" choice changes
 * anything: at least one manually edited row that is not locked.
 */
export const hasOverridableFields = (
  fields: Pick<ScalarDiffFieldOut, 'manually_edited' | 'import_locked'>[]
): boolean =>
  fields.some((field) => field.manually_edited && !field.import_locked);
